module.exports = __webpack_public_path__ + "resources/icon_94_gonggaoadd.e4bda43e4dab7b1e.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-manage/manage-dialog/img/icon_94_gonggaoadd.png
// module id = 620
// module chunks = 0 1 2 3